import Antihumidity from './../../apps/components/Antihumidity';

export default {
  path: '/placas-antihumedad',
  exact: 'true',
  component: Antihumidity,
};